import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/modal";



type Props = {
    open: boolean;
    handleClose: Function;
    handleConfirm: Function;
};

const InsightsReportDownloadModal = ( {
    open,
    handleClose,
    handleConfirm,
  }: Props) => {

    
  return (
    <Modal
    open={open}
    handleClose={handleClose}
    title="Download Report"
    showCloseButton
  >
    <div className="w-full flex flex-col gap-4">
        <p className="text-muted text-sm">Your report will be generated and sent to your email once ready. Would you like to proceed?</p>
        <div className="w-full flex items-center justify-end gap-2">
            <Button variant="ghost" onClick={() => handleClose()}>Cancel</Button>
            <Button variant="default" onClick={()=>handleConfirm()}>Yes, Continue</Button>
        </div>
    </div>
     
  </Modal>
  );
};

export default InsightsReportDownloadModal;
